import {notNull} from '../../../../../../../utils/guards'
import type {RepositoryGroup} from '../../../../services/pipelinesApi.types'

import type {PipelineRepository} from './PipelineRepositories.types'

export const includeRE = /^\+:refs\/heads\/\((.*)\)$/
export const excludeRE = /^-:refs\/heads\/\((.*)\)$/

export const getJoinedMatches = (lines: string[], re: RegExp) =>
  lines
    .map(line => line.match(re)?.[1])
    .filter(notNull)
    .join(',')

export const getFilteredRepositories = (
  repositories: PipelineRepository[],
  ownRepositoryUrl: string,
  createdRepositories: Set<string>,
) =>
  repositories.filter(
    ({htmlUrl}) => htmlUrl === ownRepositoryUrl || !createdRepositories.has(htmlUrl),
  )

export const getGroupRepositoriesFlat = (repositoryGroups: RepositoryGroup[] = []) =>
  repositoryGroups
    .map<PipelineRepository[]>(({myOwner, myRepositories}) =>
      myRepositories.map(repo => ({
        login: myOwner.login,
        avatarUrl: myOwner.avatarUrl,
        isPrivate: repo.private,
        name: repo.name,
        htmlUrl: repo.htmlUrl,
        defaultBranch: repo.defaultBranch,
      })),
    )
    .flat()

export const getRepositoryName = (url?: string) => {
  const defaultName = 'none'
  const emptyName = ''

  try {
    if (url) {
      const {pathname} = new URL(url)

      return pathname.substring(1)
    }
  } catch (e) {
    return defaultName
  }

  return emptyName
}
